<template>
  <v-app>
    <v-main class="error-wrapper d-flex align-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="10" md="8" lg="6">
            
            <v-card class="elevation-12 rounded-lg overflow-hidden border-top-error">
              <v-row no-gutters>
                
                <v-col cols="12" md="4" class="bg-gradient-error d-none d-md-flex align-center justify-center">
                  <div class="text-center">
                    <v-icon size="80" dark>mdi-shield-alert-outline</v-icon>
                    <div class="white--text font-weight-bold mt-2">LEGOR ERP</div>
                  </div>
                </v-col>

                <v-col cols="12" md="8" class="pa-8 pa-md-12 bg-white">
                  
                  <div class="d-flex align-center mb-4">
                    <v-icon color="error" class="mr-2 d-md-none">mdi-alert-circle</v-icon>
                    <h1 class="text-h4 font-weight-black grey--text text--darken-4">
                      Ups... algo falló
                    </h1>
                  </div>

                  <p class="text-body-1 mb-6 grey--text text--darken-1">
                    El sistema encontró una interrupción inesperada. Hemos registrado el evento para que nuestro equipo técnico pueda revisarlo.
                  </p>

                  <div class="error-code-box mb-8">
                    <div class="d-flex align-center mb-1">
                      <span class="text-overline error--text font-weight-bold">Detalle del error</span>
                    </div>
                    <div class="code-text">
                      {{ errorMessage || 'No se pudo determinar el mensaje de error específico.' }}
                    </div>
                  </div>

                  <div class="d-flex flex-wrap gap-3">
                    <v-btn
                      color="primary"
                      depressed
                      large
                      class="px-6 font-weight-bold"
                      @click="relaunchApp"
                    >
                      <v-icon left>mdi-rocket-launch</v-icon>
                      Reiniciar Sistema
                    </v-btn>

                    <v-btn
                      outlined
                      large
                      color="grey darken-2"
                      class="px-6 font-weight-bold"
                      @click="$router.go(-1)"
                    >
                      Regresar
                    </v-btn>
                  </div>

                  <div class="mt-10 pt-6 border-top d-flex justify-space-between align-center">
                    <span class="text-caption grey--text font-weight-medium uppercase">
                      ID: LE-{{ Date.now().toString(36).toUpperCase() }}
                    </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click="copyDetails">
                          <v-icon small color="grey lighten-1">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copiar para soporte</span>
                    </v-tooltip>
                  </div>

                </v-col>
              </v-row>
            </v-card>

            <div class="text-center mt-6">
              <span class="text-caption grey--text">
                &copy; {{ new Date().getFullYear() }} Legor ERP - Todos los derechos reservados
              </span>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GlobalErrorPage',
  computed: {
    ...mapState("initialData", ["errorMessage"])
  },
  methods: {
    relaunchApp() {
      // Forzamos limpieza total de caché y estado de ruta
      window.location.href = '/';
    },
    async copyDetails() {
      const text = `Error: ${this.errorMessage}\nPath: ${this.$route.fullPath}\nDate: ${new Date().toISOString()}`;
      await navigator.clipboard.writeText(text);
      alert('Detalles técnicos copiados al portapapeles.');
    }
  }
};
</script>

<style scoped>
/* Estilo base del envoltorio */
.error-wrapper {
  background-color: #f0f2f5;
  min-height: 100vh;
}

/* Gradiente lateral profesional */
.bg-gradient-error {
  background: linear-gradient(135deg, #FF5252 0%, #D32F2F 100%);
}

.bg-white {
  background-color: #ffffff;
}

/* Indicador de error superior */
.border-top-error {
  border-top: 4px solid #FF5252 !important;
}

/* Contenedor del código de error */
.error-code-box {
  background-color: #FFF5F5;
  border: 1px solid #FFEBEE;
  border-radius: 8px;
  padding: 16px;
}

.code-text {
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.9rem;
  color: #C62828;
  word-break: break-all;
}

.border-top {
  border-top: 1px solid #ececec;
}

.gap-3 {
  gap: 12px;
}

/* Animación de entrada */
.v-card {
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>